import React from "react";
import {
  PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, Funnel, FunnelChart, LabelList,
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid, LineChart, Line
} from "recharts";
import { DollarSign, Package, ShoppingBag, Phone, RotateCcw, TrendingUp, PhoneCall, Users, RefreshCw, Calendar } from 'lucide-react';
import { useUserContext } from "../context/DealerProfile";
import { useState, useEffect } from "react";
import useSWR from "swr";

import ExistingDonorDashboard from '../components/dashboard/ExistingDashboard.jsx';
import PotentialDonorDashboard from '../components/dashboard/PotentialDashboard.jsx';




// const MonthWiseOrdersChart = ({ selectedYear, handleYearChange }) => {


const Dashboard = ({ filter = "this-month" }) => {
  const dealerDetail = useUserContext();

  const donorType = dealerDetail?.dealerDetail?.Donor_Type?.trim().toLowerCase();

  const [activeTab, setActiveTab] = useState(
    donorType === 'existing donor' ? 'existing' : 'potential'
  );




  function TabSelector({ activeTab, setActiveTab }) {
    return (
      <div className="flex gap-4">
        <button onClick={() => setActiveTab("potential")}></button>
        <button onClick={() => setActiveTab("existing")}></button>
      </div>
    );
  }


  return (
    <div className="dashboard-container bg-gradient-to-b from-[#E7F0FA] via-white to-[#F5F7FA] min-h-screen">


      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          {/* Left Side - Welcome */}
          <div>
            <h2 className="text-lg text-gray-500">
              Welcome back,{" "}
              <span className="font-semibold text-gray-800">
                {dealerDetail?.dealerDetail?.Name}!
              </span>
            </h2>
            <h1 className="text-3xl font-bold">Dashboard</h1>
          </div>

          <div className="flex items-center justify-between mb-6 border-b border-gray-300 pb-2">
            <div className="flex gap-6">
              {(donorType !== 'existing donor') && (
                <button
                  onClick={() => setActiveTab("potential")}
                  className={`relative px-6 py-2 font-semibold rounded-lg transition-colors duration-300 focus:outline-none ${activeTab === "potential"
                      ? "bg-[#2070BC] text-white shadow-lg"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                    }`}
                >
                  Potential Donors
                  {activeTab === "potential" && (
                    <span className="absolute bottom-0 left-0 right-0 h-1 bg-[#2070BC] rounded-full" />
                  )}
                </button>
              )}

              {(donorType !== 'potential donor') && (
                <button
                  onClick={() => setActiveTab("existing")}
                  className={`relative px-6 py-2 font-semibold rounded-lg transition-colors duration-300 focus:outline-none ${activeTab === "existing"
                      ? "bg-[#2070BC] text-white shadow-lg"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                    }`}
                >
                  Existing Donors
                  {activeTab === "existing" && (
                    <span className="absolute bottom-0 left-0 right-0 h-1 bg-[#2070BC] rounded-full" />
                  )}
                </button>
              )}
            </div>
          </div>




          {/* Right Side - Filter + Refresh */}

        </div>

        <TabSelector activeTab={activeTab} setActiveTab={setActiveTab} />
        {activeTab === "potential" && <PotentialDonorDashboard />}
        {activeTab === "existing" && <ExistingDonorDashboard />}






      </div >

    </div>
  );
};

export default Dashboard;
